// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { modalButtonsActionStyles, xScreen } from "@awc/XDL/Utilities";
import { copyListFormStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsCopyListForm";
import { css } from "styled-components";

copyListFormStyles.nameTextField = {
    border: "rectangle",
    labelProps: {
        css: css`
            width: 100%;
            text-align: start;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            width: 100%;
        `,
        formField: css`
            flex-direction: column;
        `,
    },
};

copyListFormStyles.buttonsGridItem = modalButtonsActionStyles.buttonsGridItem;

copyListFormStyles.cancelButton = modalButtonsActionStyles.cancelButton;

copyListFormStyles.container = {
    gap: 20,
};

copyListFormStyles.createButton = modalButtonsActionStyles.submitButton;

copyListFormStyles.wishListDynamicDropdown = {
    labelProps: {
        css: css`
            width: 100%;
            text-align: start;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            width: 100%;
        `,
        formField: css`
            flex-direction: column;
        `,
    },
};
